import './styles.scss';
import createElement from '../../utils/createElement';
import philippinesVideo from '../../../img/philippines.mp4';
import loadVideo from '../../utils/loader';
import { rmCl, addCl } from '../../utils/elementClasses';
import Wrap from '../ScreenWrap';
import water from './water';
import RainyDay from '../../lib/rainyday';
import { isSafari, isFirefox, isWindows } from '../../utils/checkBrowser';

class Screen3 {
    constructor(loader, updateParams){
        this.html = {};
        this.wrap = null;
        this.loader = loader;
        this.updateParams = updateParams;

        this.isFocused = false;
        this.isEntered = false;
        this.isLoaded = false;

        this.autoplayVideo = false;
        this.AUTOPLAY_FROM_PERCENT = 60;
        this.TIME_TO_REPEAT = 5000;

        this.showHelp = true;

        this.toBeginTimeout = null;
        this.request = null;
        this.lastLoadedPercent = 0;

        this.ic = 'philippines_invisible';

        this.currentGuiAction = null;

        this.initListeners = this.initListeners.bind(this);
        this.toBegin = this.toBegin.bind(this);
        this.insertRequest = this.insertRequest.bind(this);
        this.checkVideoProgress = this.checkVideoProgress.bind(this);
    }

    render(mountNode){
        this.html.mountNode = mountNode;

        this.html.mainTitle = <h2 class="philippines__main-title">
            Филип
            <br/>
            пины
        </h2>;

        this.html.shadowFilter = <div class="philippines__shadow-filter"/>;

        this.html.countryName = <h3 class="philippines__country-name">Филиппины</h3>;

        this.html.video = <video
            class="philippines__video"
            id="philippines-video"
            muted
        />;

        this.html.content1 = <div class="philippines__content-1">
            { this.html.title1 = <h3 class="philippines__title-1">
                Погру
                <br/>
                жение
            </h3> }
            { this.html.help1 = <span class="philippines__help">
                Удерживай клавишу
                <br/>
                «Пробел»,
                <br/>
                чтобы серфить на волне
            </span> }
        </div>;

        this.html.content2 = <div class="philippines__content-2">
            { this.html.title2 = <h3 class="philippines__title-2">Работает даже<br/>под водой</h3> }
            { this.html.help2 = <span class="philippines__help">
                Стандарт защиты IP68.
                <br/>
                Выдерживает
                <br/>
                30-минутное погружение
                <br/>
                на глубину до 1,5 м
            </span> }
        </div>;

        this.html.drops = <div class="drops">
            <canvas id="container" width="260" height="580" style="position:absolute;top:0;left:0;width:100%;height:100%"></canvas>
        </div>;

        this.html.container = <div class="philippines" id="philippines">
            { this.html.shadowFilter }
            { this.html.video }
            { this.html.mainTitle }
            { this.html.countryName }
            { this.html.drops }
            { this.html.content1 }
            { this.html.content2 }
        </div>;

        this.wrap = new Wrap(this.html.container);
        this.wrap.mountTo(this.html.mountNode);

        if (!isSafari() && !(isFirefox() && !isWindows())) {
            water(renderer => { this.water = renderer });
        }
        //this.rain();
        this.initListeners();
        this.guiAction('inactive');
    }

    initListeners(){
        const self = this;

        const can = () => this.isFocused && this.isEntered && this.isLoaded;

        this.html.video.addEventListener('timeupdate', event => {
            if (self.checkVideoProgress() && can()) {
                if (!self.autoplayVideo) {
                    this.autoplayVideo = true;
                    var isPlaying = self.html.video.currentTime > 0 && !self.html.video.paused && !self.html.video.ended
                        && self.html.video.readyState > 2;

                    if (!isPlaying) {
                        self.html.video.play();
                    }
                    //self.html.video.play();
                }
            }
        }, false);

        this.html.video.addEventListener('ended', event => {
            if (can()) {
                if (self.toBeginTimeout){
                    clearTimeout(self.toBeginTimeout);
                }
                self.toBegin();
                //self.toBeginTimeout = setTimeout(() => {
                //    self.toBegin();
                //}, self.TIME_TO_REPEAT);
            }
        }, false);

        window.addEventListener('keyup', event => {
            if (event.keyCode === 32 && can()){
                if (!self.checkVideoProgress()) {
                    var isPlaying = self.html.video.currentTime > 0 && !self.html.video.paused && !self.html.video.ended
                        && self.html.video.readyState > 2;
                    if (isPlaying) {
                        self.html.video.pause();
                    }

                    // ???
                    // if (!this.showHelp){
                    //     this.guiAction('content1');
                    // }
                }
            }
        }, false);

        window.addEventListener('keydown', event => {
            if (event.keyCode === 32 && can()) {
                if(!self.checkVideoProgress()){
                    var isPlaying = self.html.video.currentTime > 0 && !self.html.video.paused && !self.html.video.ended
                        && self.html.video.readyState > 2;

                    if (!isPlaying) {
                        self.html.video.play();
                    }
                    //self.html.video.play();
                }
                if (this.showHelp){
                    this.showHelp = false;
                }

                // ???
                // if (!this.showHelp){
                //     if (!self.checkVideoProgress()) {
                //         this.guiAction('content1');
                //     }
                // }
            }
        }, false);
    }

    paramsUpdated() {
        if (this.isFocused) {
            this.updateParams(this.isFocused, this.isEntered, this.isLoaded);
        }
    }

    size(heigth, width){
        this.wrap.size(heigth, width);
    }

    focus() {
        this.isFocused = true;
        this.paramsUpdated();
    }

    unFocus() {
        this.isFocused = false;
        this.paramsUpdated();
        this.toBegin();
    }

    clickEnter() {
        this.isEntered = true;
        this.paramsUpdated();
        if (!this.isLoaded){
            this.guiAction('loading');
            this.loader.loadStarted(this.lastLoadedPercent);
            this.loadVideo();
        }else{
            this.loaded();
        }
    }

    preload() {
        loadVideo(philippinesVideo,
            p => {
                // console.log('phil', p);
                this.lastLoadedPercent = p;
                if (this.isFocused && this.isEntered) { this.loader.progress(p) }
            },
            0).then( videoSrc => {
            this.html.video.src = videoSrc;
            if (this.isFocused && this.isEntered) {
                this.loaded();
                this.loader.loadFinished();
            }
        });
    }

    loadVideo() {
        const self = this;
        //loadVideo(philippinesVideo, this.loader.progress, 0, this.insertRequest).then( videoSrc => {
        //    self.html.video.src = videoSrc;
        //    self.loaded();
        //    self.loader.loadFinished();
        //});
        if (this.html.video.src) {
            self.loaded();
            self.loader.loadFinished();
        }
    }

    loaded() {
        this.isLoaded = true;
        this.paramsUpdated();
        this.toBegin();
    }

    clickExit() {
        this.isEntered = false;
        this.html.drops.style.opacity = 0;
        this.water.playing = false;
        this.paramsUpdated();
        this.guiAction('nothing');
        try {
            this.html.video.currentTime = 0;
            this.html.video.pause();
        } catch (e) {}
        this.guiAction('inactive');
    }

    guiAction(action){

        const ic = this.ic;

        if (this.currentGuiAction === action){
            return;
        }

        this.currentGuiAction = action;

        addCl([
            this.html.mainTitle,
            this.html.countryName,
            this.html.content1,
            this.html.content2,
            this.html.help1,
            this.html.video
        ], ic);

        switch (action){
            case 'inactive':
                rmCl(this.html.mainTitle, ic);
                break;

            case 'loading':
                rmCl(this.html.countryName, ic);
                break;

            case 'content1 and help':
                rmCl([
                    this.html.content1,
                    this.html.countryName,
                    this.html.help1,
                    this.html.video
                ], ic);
                break;

            case 'content1':
                rmCl([
                    this.html.content1,
                    this.html.countryName,
                    this.html.video
                ], ic);
                break;

            case 'content2':
                rmCl([
                    this.html.content2,
                    this.html.countryName,
                    this.html.video
                ], ic);
                if (this.isEntered && this.isFocused) {
                    ga('s8.send', 'event', 'Philippines', 'final_text');
                }
                break;

            case 'nothing':
                rmCl([
                    this.html.countryName,
                    this.html.video
                ], ic);
                break;
        }
    }

    checkVideoProgress(){
        const low = 16;
        const high = 70;

        const title1Low = 0;
        const title1High = 10;

        const content2From = 71;
        const content2To = 101;

        const p = Math.round(this.html.video.currentTime * 100 /this.html.video.duration);
        if (this.water) {
            if (p > low && p < high) {
                this.html.drops.style.opacity = 1;
                this.water.playing = true;
            } else {
                this.html.drops.style.opacity = 0;
                this.water.playing = false;
            }
        }

        if (p > title1Low && p < title1High) {
            if (this.showHelp){
                this.guiAction('content1 and help');
            }else{
                this.guiAction('content1');
            }
        }

        if (p > title1High && p < content2From){
            this.guiAction('nothing');
        }

        if (p > content2From && p < content2To) {
            this.guiAction('content2')
        }


        return p >= this.AUTOPLAY_FROM_PERCENT;
    }

    toBegin(){
        const self = this;
        if (this.isLoaded && this.isEntered) {

            if (self.toBeginTimeout){
                clearTimeout(self.toBeginTimeout);
            }
            this.autoplayVideo = false;
            this.showHelp = true;
            this.guiAction('loading');

            try {
                self.html.video.currentTime = 0;
            } catch (e) {}
            var isPlaying = self.html.video.currentTime > 0 && !self.html.video.paused && !self.html.video.ended
                && self.html.video.readyState > 2;
            if (isPlaying) {
                self.html.video.pause();
            }
            self.guiAction('content1 and help');
        }else{
            if (this.request){
                this.request.abort();
            }
            this.loader.loadFinished();
            this.guiAction('inactive');
            this.isEntered = false;
            this.updateParams();
        }
    }

    insertRequest(request){
        this.request = request;
    }
}


export default Screen3;


// WEBPACK FOOTER //
// ./src/js/screens/Screen3/index.js